import { MODEL_IDS } from './modelIds';

const MODEL_DEFINITIONS = [
  { value: 'rollo', name: 'Rollo', img: 'resources/rollo.jpg' },
  { value: 'panel', name: 'Panel', img: 'resources/panels.jpg' },
  { value: 'banner', name: 'Banner', img: 'resources/banners.jpg' },
  { value: 'flow', name: 'Flow', img: 'resources/flow.jpg' },
  { value: 'slides', name: 'Slides', img: 'resources/slides.jpg' },
  { value: 'follo', name: 'Follo', img: 'resources/follo.jpg' }
];

export { MODEL_IDS };

export default MODEL_DEFINITIONS.map((definition) => ({
  ...definition,
  id: MODEL_IDS[definition.value]
}));
